import React from "react"
import Flex from "@irati/ui/src/Flex"
import styled from "styled-components"
import {Hr} from "@irati/ui/src/Layout"

export function Row({children, simple}: {children: React.ReactNode; simple?: boolean}) {
  return (
    <>
      {simple ? <SimpleRow>{children}</SimpleRow> : <RowGrid>{children}</RowGrid>}
      <Hr flush />
    </>
  )
}

const SimpleRow = styled.div`
  display: grid;
  gap: ${({theme}) => theme.spacing.two};
  grid-template-rows: auto;

  grid-template-columns: 40px 1fr minmax(50px, 220px);
  grid-template-areas: "icon name amount";

  /* this is to line up with the menu column below */
  margin-right: 30px;
  ${({theme}) => theme.mediaQueries.maxWidthMedia.phoneLandscape`
      margin-right: 0px;
  `}
`

const RowGrid = styled.div`
  display: grid;
  gap: ${({theme}) => theme.spacing.two};
  grid-template-rows: auto;
  grid-template-columns: 40px 1fr 30px;
  grid-template-areas:
    "icon   name   menu"
    "icon   tag    menu"
    "icon   amount menu";

  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    grid-template-columns: 40px minmax(200px, 300px) 1fr minmax(150px, 220px) 30px;
    grid-template-areas:
      "icon   name   gap    amount menu"
      "icon   tag    gap    amount menu";
  `};

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    grid-template-columns: 40px minmax(200px, 300px) minmax(200px, 300px) 1fr minmax(150px, 220px) 30px;
    grid-template-areas: 
      "icon name tag gap amount menu";
  `};
`

export const Item = styled(Flex)<{area: "icon" | "name" | "tag" | "menu" | "amount"}>`
  flex-direction: column;
  grid-area: ${({area}) => area};
`
